export default __webpack_public_path__ + "static/media/portail_5.5df71ec7.png";